import { ExtractSession } from "./SessionExtract";

const checkSession = ExtractSession('auth');
// ExtractSession("auth").then((data) => {
//     console.log("user", data);
// });
export const useAuthSession = () => {
    ExtractSession("auth").then((data) => {
        // console.log("user", data);
        if (data?.token) {
            return true;
        } else {
            return false
        }
    });

};
export const useAuthSAdmin = () => {
    //getting token from local storage
    // const user = localStorage.getItem('SAToken');
    const user = JSON.parse(sessionStorage.getItem('auth'));
    // const user = ExtractSession('auth');
    // console.log('user',user);
    // let user = false;
    // ExtractSession("auth").then((data) => {
        
    //     if (data?.token && data?.login_user_type === 'SA') {
            
    //         user = true;
    //     } else {
    //         user = false
    //     }
    // })
    // // console.log('T', user);
    // return user;
    // console.log("user", user);
    // const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (user?.token && user?.login_user_type === 'SA') {
        console.log('T');
        return true;
    } else {
        return false
    }
};
export const useAuthServer = () => {
    //getting token from local storage
    const user = localStorage.getItem('ServerIWI');
    // const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (user) {
        return true;
    } else {
        return false
    }
};
export const useAuthAirline = () => {
    //getting token from local storage
    const user = localStorage.getItem('airlinetoken');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (user && SROrg === 'A') {
        return true;
    } else {
        return false
    }
};
export const useAuthHandler = () => {
    //getting token from local storage
    const user = localStorage.getItem('airlinetoken');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (user && SROrg === 'H') {
        return true;
    } else {
        return false
    }
};
export const useAuthForwarder = () => {
    //getting token from local storage
    const user = localStorage.getItem('airlinetoken');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (user && SROrg === 'E') {
        return true;
    } else {
        return false
    }
};

export const useAuth = () => {
    //getting token from local storage
    const user = localStorage.getItem('token')
    //checking whether token is preset or not
    if (user) {
        return true;
    } else {
        return false
    }
};
export const useAuthRFS = () => {
    //getting token from local storage
    const RFSuser = localStorage.getItem('RFS');
    const ULDuser = localStorage.getItem('ULD');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (RFSuser && !ULDuser && SROrg === 'A') {
        return true;
    } else {
        return false
    }
};
export const useAuthFTM = () => {
    //getting token from local storage
    const RFSuser = localStorage.getItem('RFS');
    const FTMuser = localStorage.getItem('FTM');
    const ULDuser = localStorage.getItem('ULD');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (FTMuser && !RFSuser && !ULDuser && SROrg === 'A') {
        return true;
    } else {
        return false
    }
};
export const useAuthTKM = () => {
    //getting token from local storage
    const RFSuser = localStorage.getItem('RFS');
    const FTMuser = localStorage.getItem('TKM');
    const ULDuser = localStorage.getItem('ULD');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (FTMuser && !RFSuser && !ULDuser && SROrg === 'A') {
        return true;
    } else {
        return false
    }
};
export const useAuthQMS = () => {
    //getting token from local storage
    const user = localStorage.getItem('QMS');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (user && SROrg === 'A') {
        return true;
    } else {
        return false
    }
};
export const useAuthQUT = () => {
    //getting token from local storage
    const user = localStorage.getItem('RFS');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (user && SROrg === 'E') {
        return true;
    } else {
        return false
    }
};
export const useAuthFSHP = () => {
    //getting token from local storage
    const RFSuser = localStorage.getItem('RFS');
    const ULDuser = localStorage.getItem('ULD');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (RFSuser && !ULDuser && SROrg === 'E') {
        return true;
    } else {
        return false
    }
};
export const useAuthTrucking = () => {
    //getting token from local storage
    const Truckinguser = localStorage.getItem('Trucking');
    //checking whether token is preset or not
    if (Truckinguser) {
        return true;
    } else {
        return false
    }
};

export const useAuthULD = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const ULDuser = localStorage.getItem('ULD');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (ULDuser && SROrg === 'A') {
        return true;
    } else {
        return false
    }
};
export const useAuthFULD = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const ULDuser = localStorage.getItem('ULD');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (ULDuser && SROrg === 'E') {
        return true;
    } else {
        return false
    }
};
export const useAuthHULD = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const ULDuser = localStorage.getItem('ULD');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (ULDuser && SROrg === 'H') {
        return true;
    } else {
        return false
    }
};
export const useAuthDVR = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const ULDuser = localStorage.getItem('DVR');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (ULDuser && ['H', 'E'].includes(SROrg)) {
        return true;
    } else {
        return false
    }
};
export const useAuthHDVR = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const ULDuser = localStorage.getItem('DVR');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (ULDuser && SROrg === 'H') {
        return true;
    } else {
        return false
    }
};
export const useAuthFDVR = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const ULDuser = localStorage.getItem('DVR');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (ULDuser && SROrg === 'E') {
        return true;
    } else {
        return false
    }
};
export const useAuthNTOKEN = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const ULDuser = localStorage.getItem('NO_TOKEN');
    //checking whether token is preset or not
    if (ULDuser) {
        return true;
    } else {
        return false
    }
};
export const useAuthASR = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const SRuser = localStorage.getItem('ASR');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (SRuser && SROrg === 'A') {
        return true;
    } else {
        return false
    }
};
export const useAuthHSR = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const SRuser = localStorage.getItem('ASR');
    const SRorg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (SRuser && SRorg === 'H') {
        return true;
    } else {
        return false
    }
};
export const useAuthHRFS = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const SRuser = localStorage.getItem('RFS');
    const SRorg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (SRuser && SRorg === 'H') {
        return true;
    } else {
        return false
    }
};
export const useAuthHSPL = () => {
    //getting token from local storage
    const SRuser = localStorage.getItem('SPL');
    const SRorg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (SRuser && SRorg === 'H') {
        return true;
    } else {
        return false
    }
}

export const useAuthEmail = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const ULDuser = localStorage.getItem('EMAIL');
    //checking whether token is preset or not
    if (ULDuser) {
        return true;
    } else {
        return false
    }
};
export const useAuthTEmail = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const ULDuser = localStorage.getItem('TEMAIL');
    //checking whether token is preset or not
    if (ULDuser) {
        return true;
    } else {
        return false
    }
};
export const useAuthTTracker = () => {
    //getting token from local storage
    // const RFSuser = localStorage.getItem('RFS');
    const ULDuser = localStorage.getItem('TTRACKER');
    //checking whether token is preset or not
    if (ULDuser) {
        return true;
    } else {
        return false
    }
};
export const useAuthBroker = () => {
    const user = localStorage.getItem('airlinetoken');
    const SROrg = localStorage.getItem('OrgType');
    //checking whether token is preset or not
    if (user && SROrg === 'B') {
        return true;
    } else {
        return false
    }
};